import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Building2 } from "lucide-react";
import Seo from "@/components/Seo";

export default function Register() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Seo
        title="Provider access starts with a listing claim"
        description="Provider accounts on Strategic Tracking are created after a listing claim or submission is reviewed. Search for your company or submit a new one to start."
      />
      <div className="max-w-3xl mx-auto px-4 py-20">
        <div className="text-xs uppercase tracking-widest text-[#002FA7] font-semibold">For providers</div>
        <h1 className="font-display font-extrabold text-3xl sm:text-5xl text-slate-900 mt-2 leading-tight">
          Provider access starts with a listing claim
        </h1>
        <p className="mt-5 text-slate-600 max-w-2xl leading-relaxed">
          To manage a company profile in the Strategic Tracking Solution Directory, first claim an existing listing or
          submit a new company for review. Once approved, you’ll receive access to manage your listing.
        </p>

        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          <Link
            to="/list-your-company"
            className="card-elevated p-7 block border-2 border-transparent hover:border-[#002FA7] hover:-translate-y-0.5 transition-all"
            data-testid="register-claim-cta"
          >
            <div className="w-11 h-11 rounded-md bg-slate-900 text-white grid place-items-center"><Building2 size={18}/></div>
            <div className="mt-4 font-display font-extrabold text-xl text-slate-900">Claim or submit listing</div>
            <p className="text-sm text-slate-600 mt-2">Search for your company to claim it, or submit a new company for review.</p>
            <div className="mt-4 text-sm font-semibold text-[#002FA7] inline-flex items-center gap-2">Get started <ArrowRight size={14}/></div>
          </Link>
          <Link
            to="/login"
            className="card-elevated p-7 block border-2 border-transparent hover:border-slate-300 hover:-translate-y-0.5 transition-all"
            data-testid="register-login-cta"
          >
            <div className="w-11 h-11 rounded-md bg-emerald-600 text-white grid place-items-center"><ShieldCheck size={18}/></div>
            <div className="mt-4 font-display font-extrabold text-xl text-slate-900">Already approved? Log in</div>
            <p className="text-sm text-slate-600 mt-2">If your claim or submission has been approved, sign in with the email you used.</p>
            <div className="mt-4 text-sm font-semibold text-emerald-700 inline-flex items-center gap-2">Sign in <ArrowRight size={14}/></div>
          </Link>
        </div>

        <p className="mt-10 text-xs text-slate-500 max-w-2xl">
          Open provider self-registration has been turned off. The correct provider funnel is:
          <span className="font-mono"> Pricing → Claim or submit → Admin review → Set-password link → Provider dashboard</span>.
        </p>
      </div>
    </div>
  );
}
